// VideoCarousel.jsx
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './carousel.css'; // Custom CSS for styling
import ProductImg from "../../assets/Section/productimg.png";
import { ArrowRightIcon } from '@heroicons/react/16/solid';
import { ChevronRight, X } from 'react-bootstrap-icons';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import ProfileImg from "../../assets/modal/profile.png";
import BgImg from "../../assets/modal/quotes.png";
import { isMobile } from 'react-device-detect';
import { useSearchParams } from 'react-router-dom';


const CategoryListCarousel = ({ data, handleActiveProduct, colors }) => {  
  const [searchParams] = useSearchParams();
  const temp_id = searchParams.get('template_id');
  const [open, setOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [productId, setProductId] = useState(null);
  
  useEffect(() => {
    if (data?.length > 0) {
      if (temp_id) {
        const foundObjects = data.filter(obj => obj.template_id == temp_id);
        handleActiveProduct(foundObjects[0]);
        setProductId(foundObjects[0]?.template_id);
      } else {
        handleActiveProduct(data[0]);
        setProductId(data[0]?.template_id);
      }
    }
  }, [data]);
  
  const settings = {
    dots: false,
    dotsClass: "slick-dots",
    infinite: false,
    speed: 500,
    slidesToShow: 5 ,
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    responsive: [
      {
        breakpoint: 768, // This is the breakpoint for mobile devices
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1,
        }
      }
    ]
  };  
  
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    const headerOffset = isMobile ? 80:50; // Adjust based on the header height
    const elementPosition = section?.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };

  return (
    <>
    <div className="client text-left">         
        <Slider {...settings} className={`w-full py-2 max-sm:pb-0 max-sm:pt-0 m-auto`}>
          {data?.map((rev, index) => (
            <div
              key={index}
              onClick={() => {
                handleActiveProduct(rev); 
                setProductId(rev?.template_id);
                const url = new URL(window.location);
                url.searchParams.delete('template_id');
                window.history.pushState({}, '', url);
                scrollToSection("section-7");
              }}
              className={`${rev?.template_id == productId ? "opacity-100" : "opacity-50"} text-gray-600 cursor-pointer outline-none`}
            >
                <img 
                  src={rev?.microsite_img} 
                  alt="QuoteImg" 
                  className={`rounded-t-2xl hover:border-2 ${rev?.template_id == productId ? "border-2" : ""}`}
                  style={{ 
                    borderColor: rev?.template_id == productId ? colors?.primary : '',
                    ...(rev?.template_id != productId && { '&:hover': { borderColor: colors?.primary } })
                  }}
                />  
                <p title={rev?.title} style={{ color: colors?.primary }} className='capitalize p-2 max-sm:px-0 text-xs max-sm:text-[10px] not-italic font-semibold leading-[132%] text-left'>{ rev?.title?.slice(0,25) }{ rev?.title?.length > 25 ? "...":"" }</p>
            </div>
          ))}
        </Slider>
      </div>
      <Transition show={open}>
        <Dialog className="relative z-10" onClose={setOpen}>
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel className="relative transform overflow-hidden rounded-lg bg-[#E1DFE0] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">
                  <div className='bg-no-repeat bg-[65px] space-y-8 p-8' style={{ backgroundImage: `url(${BgImg})`, backgroundPositionY: "20%" }}>
                    <X className="absolute right-2 top-2 z-50 text-[#222] cursor-pointer text-2xl" onClick={() => setOpen(false)} />
                    <div className='space-y-2'>
                      <div className='flex justify-center'>
                        <img className='rounded-full' src={popupData?.image} alt="profile" />
                      </div>
                      <p className='w-ful font-[TATAAIARegularPrint] text-center text-[10px]'>{popupData?.name}, { popupData?.designation !== "" ? popupData?.designation : popupData?.company }</p>
                    </div>
                    <div className='space-y-8 font-[HelveticaNeueLTStd]  text-sm text-[#222]'>
                      {popupData?.message}
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default CategoryListCarousel;